(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('StatusAlumnoPlanDeEstudiosDeleteController',StatusAlumnoPlanDeEstudiosDeleteController);

    StatusAlumnoPlanDeEstudiosDeleteController.$inject = ['$uibModalInstance', 'entity', 'StatusAlumnoPlanDeEstudios'];

    function StatusAlumnoPlanDeEstudiosDeleteController($uibModalInstance, entity, StatusAlumnoPlanDeEstudios) {
        var vm = this;

        vm.statusAlumnoPlanDeEstudios = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            StatusAlumnoPlanDeEstudios.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
